import { createRouter, createWebHistory, NavigationGuardWithThis, RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    component: () => import('./views/Home.vue'),
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: '首页',
        component: () => import('./views/Index.vue')
      },
      {
        path: '/download',
        name: '下载',
        component: () => import('./views/Download.vue')
      },
      {
        path: '/slides',
        name: 'Keynote',
        component: () => import('./views/Keynote.vue')
      },
      {
        path: '/privacy',
        name: '隐私政策',
        component: () => import('./views/Privacy.vue')
      },
      {
        path: '/about',
        name: '关于',
        component: () => import('./views/About.vue')
      },
      {
        path: '/:pathMatch(.*)*',
        component: () => import('./views/NotFound.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory('/2022/'),
  scrollBehavior: () => ({ top: 0 }),
  routes
})

export default router
